// extracted by mini-css-extract-plugin
module.exports = {"modal_body":"MobileReviewReceivedProposalModal_modal_body__3NoSF","footer":"MobileReviewReceivedProposalModal_footer__37urV","icon":"MobileReviewReceivedProposalModal_icon__1BsZ_"};